var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-upload-102355",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.641,
    height: 14.642,
    viewBox: "0 0 16.641 14.642",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5834",
    "data-name": "Path 5834",
    d: "M180.291,318.44v3.686H167.348V318.44H165.5v5.529H182.14V318.44Z",
    transform: "translate(-165.499 -309.327)",
    fill: "#525252",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5835",
    "data-name": "Path 5835",
    d: "M4.058,3.5v7.451H5.907V3.5l2.75,2.741,1.308-1.3L5.005,0,0,4.943l1.308,1.3Z",
    transform: "translate(13.303 10.956) rotate(180)",
    fill: "#525252",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.58bff85a4efdb6624a647771f59d40de.svg";
export { ForwardRef as ReactComponent };